import React, {useEffect,useState} from 'react'
import infos from './data'
import Fade from 'react-reveal/Fade'
import { PortafolioContainer, PortafolioH2, PortafolioWrapper, 
    PortafolioCard,PortafolioIcon,PortafolioH3,PortafolioControls,PortafolioButtton,PortafolioDescription,Portafolioicono} from './PortafolioElements'
import './index.css';
const Portafolio = () => {
    const [tag, setTag] = useState('all');
	const [filteredInfos, setFilteredInfos] = useState([]);

	useEffect(
		() => {
			tag === 'all' ? setFilteredInfos(infos) : setFilteredInfos(infos.filter(infos => infos.tag === tag));
		},
		[tag]
	);
  return (
    <PortafolioContainer id='Portafolio'>
        <PortafolioH2>
        Portafolio del Jimmy
        </PortafolioH2>
        <PortafolioControls>
            <TagButton name="all" tagActive={tag === 'all' ? true : false} handleSetTag={setTag} />
			<TagButton name="Proyecto-Laboral" tagActive={tag === 'Proyecto-Laboral' ? true : false} handleSetTag={setTag} />
			<TagButton name="Proyectos-de-Practica" tagActive={tag === 'Proyectos-de-Practica' ? true : false} handleSetTag={setTag} />
			<TagButton name="Proyectos-en-Figma" tagActive={tag === 'Proyectos-en-Figma' ? true : false} handleSetTag={setTag} />
        </PortafolioControls>
        <PortafolioWrapper>
            {filteredInfos.map(infos => (
                            
                            <PortafolioCard key={infos.id}>
                                <Fade bottom>
                                <Portafolioicono strong={infos.strong ? 1 : 0}/>
                                <PortafolioH3>
                                    <PortafolioIcon href={`${infos.websiteName}`} target="_blank" rel="noopener"> 
                                          {infos.proyectName}
                                    </PortafolioIcon>
                                </PortafolioH3>
                                <PortafolioDescription>
                                    {infos.description}
                                </PortafolioDescription>
                                <PortafolioButtton href={`${infos.websiteName}`} target="_blank" rel="noopener">
                                    Ver Proyecto
                                </PortafolioButtton>
                                </Fade>
                            </PortafolioCard>
                           
                        ))}
        </PortafolioWrapper>
</PortafolioContainer>
  )
}
const TagButton = ({ name, handleSetTag, tagActive }) => {
	return (
		<button className={`tag ${tagActive ? 'activet' : null}`} onClick={() => handleSetTag(name)}>
			{name.toUpperCase()}
		</button>
	);
};

export default Portafolio
